
import Vue from 'vue'
import { listCustomerInvoices } from '@/api/cloudFunctionWrappers'
import RLoader from '@/components/forms/RLoader.vue'
import RTable from '@/components/platform/RTable.vue'
import { formatPriceFromCents } from '@/services/prices'
import { secondsToMiliseconds } from '@/services/time'

/**
 * Helper - provide the expected elemented template string
 * for a given invoice status. All params come from (after renaming)
 * from Stripe Invoice object
 * @param paid: a boolean indicating whether the invoice was paid
 * @param url: a string directing to where the invoice can be paid
 * @param pdf: a string directing to invoice PDF
 * @returns a markup string of desired table cell content
 */
function getProperInvoiceCellContent(paid: boolean, url: string, pdf: string): string {
  if (paid) {
    return `<a href="${pdf}" rel="noopener noreferrer" download>Download</a>`
  }
  return `<a href="${url}" rel="noopener noreferrer" target="_blank">Pay</a>`
}

export default Vue.extend({
  name: 'BillingHistory',
  components: {
    RTable,
    RLoader,
  },
  props: {
    missing_payment_only: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      invoices: null,
    }
  },
  async mounted() {
    this.invoices = await listCustomerInvoices()
  },
  computed: {
    header(): string[] {
      return ['date', 'title', 'amount', 'status', 'invoice']
    },
    rows(): any[] {
      return this.invoicesData(this.missing_payment_only).map((dataRow: any) => {
        const { key, date, description, status, pdf, amount_due, url, paid } = dataRow
        return {
          key,
          columns: [
            date,
            description,
            `$${amount_due}`,
            status,
            getProperInvoiceCellContent(paid, url, pdf),
          ],
        }
      })
    },

    noInvoices(): boolean {
      return (
        (this.invoices && this.invoices.data === null) ||
        (this.invoices && this.invoices.data && this.invoices.data.length === 0) ||
        (this.invoices && !!!this.rows.length)
      )
    },
  },
  methods: {
    invoicesData(missing_payment_only: boolean): Array<any> {
      if (!this.invoices) {
        return []
      }

      if (!this.invoices.data) {
        return []
      }

      const unpaidInvoices = this.invoices.data.filter((invoice: any) => {
        invoice.status !== 'paid'
      })

      const invoicesToShow = missing_payment_only ? unpaidInvoices : this.invoices.data

      return (invoicesToShow as any).map((invoice: any) => {
        const linesDesc = invoice.lines ? invoice.lines.data[0].description : 'unknown'
        return {
          key: invoice.id,
          date: new Date(secondsToMiliseconds(invoice.created)).toISOString().slice(0, 10),
          description: invoice.description || linesDesc,
          status: invoice.status.toUpperCase(),
          paid: invoice.paid,
          pdf: invoice.invoice_pdf,
          url: invoice.hosted_invoice_url,
          amount_due: formatPriceFromCents(invoice.amount_due),
        }
      })
    },
  },
})
